import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'apiBannerClick', 
  'apiBannerClose',
  'scaleAdsMenuItemClicked',
  'scaleAdsProjectsBannerClicked',
  'scaleAdsSidebarBannerClicked',
  'scaleAdsSidebarBannerClose',
] as const;

export const bannerSidebarEvents = getMappedEvents([...EVENTS]);
